import { css } from '@emotion/react';

export const additional_cta_button = css`
  margin-left: auto;
`;
